import { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import useAnchoredToRect from "../hooks/useAnchoredToRect";
import "./AddHighlightPopover.css";

const POPOVER_HEIGHT_ESTIMATE = 200;
const PREVIEW_TEXT_MAX_LENGTH = 100;

function AddHighlightPopover({
  onSave,
  onCancel,
  selectionRect,
  getViewportRect,
  text,
}) {
  const [note, setNote] = useState("");
  const popoverRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(() => {
    // autoFocus fires before VoiceOver on Safari builds the label association.
    // Deferring focus gives the accessibility tree time to settle.
    const id = setTimeout(() => textareaRef.current?.focus(), 50);
    return () => clearTimeout(id);
  }, []);

  function handleSave() {
    onSave(note.trim() || null);
    setNote("");
  }

  function handleCancel() {
    setNote("");
    onCancel();
  }

  const { style } = useAnchoredToRect(
    popoverRef,
    getViewportRect,
    selectionRect,
    POPOVER_HEIGHT_ESTIMATE,
  );

  const previewText = text
    ? text.length > PREVIEW_TEXT_MAX_LENGTH
      ? text.slice(0, PREVIEW_TEXT_MAX_LENGTH) + "…"
      : text
    : null;

  return (
    <div ref={popoverRef} style={style}>
      <div className="addHighlightPopover bg-white shadow-lg overflow-hidden">
        <div className="d-flex align-items-center justify-content-between pt-4 px-4 pb-3">
          <h2 className="addHighlightPopover__title mb-0 font-weight-bold">
            Add Note
          </h2>
          <button
            type="button"
            className="close"
            onClick={handleCancel}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="d-flex flex-column px-4 pb-4">
          {previewText && (
            <div className="addHighlightPopover__quote font-italic p-3 rounded mb-3">
              &ldquo;{previewText}&rdquo;
            </div>
          )}
          <Form.Control
            as="textarea"
            aria-label="Add a note"
            id="add-highlight-note"
            ref={textareaRef}
            rows={4}
            placeholder="Write your note..."
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <div className="addHighlightPopover__hint bg-light rounded p-3 small mb-3">
            Leave the note blank to save just the highlight.
          </div>
          <div className="d-flex justify-content-end">
            <Button variant="outline-secondary" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              variant="primary"
              className="addHighlightPopover__btn--save ml-3"
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddHighlightPopover;
